export const isNonEmptyString = value => !!value && typeof value === 'string';